import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { APIClient } from "../../../api/apiCore";
import { MemberRole, WorkPlaceFilterSel, WorkPlaceCatFilter, WorkPlaceTagFilter, sp_WpFindTag, WpLoadTagMemberDtl, QuillTagData } from "../../../redux/workplace/wpTypes";
import * as urls from "../../../api/urls";
import { Utils } from "helpers/utils";
import { Tab, Tabs } from "react-bootstrap";
import TextBox from "components/TextBox";
import Loader from "components/Loader";
import AppSimpleBar from "components/AppSimpleBar";
import classnames from "classnames";
import UserAvatar from "components/UserAvatar";
import { debounce, last, set } from "lodash";
import { Const } from "const";
import { DbUtils } from "helpers/dbUtils";

interface WpTagToolboxProps {
  isOpen: boolean
  onClickTag(tagId: number, tagName: string, isAdd: boolean): void;
  selectedTags: QuillTagData[];
}
const WpTagToolbox = ({
  isOpen,
  onClickTag,
  selectedTags,
}: WpTagToolboxProps) => {

  const [allTags, setAllTags] = useState<WorkPlaceCatFilter[]>([]);
  const [selTab, setSelTab] = useState<string>("");
  const divContainer = useRef<HTMLDivElement>(null);

  const fnSetTag = (rs: any[]) => {
    if (rs == null) return;
    if (rs.length > 0) {
      setSelTab(rs[0].category);
    }
    setAllTags(rs);
  }

  useEffect(() => {
    try{
      DbUtils.wp_load_tag_for_toolbox().then(rs => fnSetTag(rs));
    }catch(e1){
      Utils.HandleException(e1, false);
    }

    const api = new APIClient();
    api.fnPostForm(urls.WP_LOAD_TAG_FOR_TOOLBOX, {})
      .then(rs => {
        // console.log('WP_LOAD_TAG_FOR_TOOLBOX:', rs);
        // // rs.forEach((a: any) => a.showSearchBox = a.tags === null);
        // if (rs.length > 0) {
        //   setSelTab(rs[0].category);
        // }
        // setAllTags(rs);
        fnSetTag(rs);
        DbUtils.wp_load_tag_for_toolbox(rs);
        // console.log('all tag toolbox:', rs);
      })
      .catch(e2 => Utils.HandleException(e2, false));
  }, []);

  useEffect(() => {
    const handleWindowResize = () => {
      if (divContainer.current) {
        const x = divContainer.current.offsetWidth;
        const y = divContainer.current.offsetHeight;
        console.log('Win = ' + window.innerWidth + 'x' + window.innerHeight + ', Ctn = ' + x + 'x' + y);
      }


    };

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  const [tagMembers, setTagMembers] = useState<WpLoadTagMemberDtl[]>([]);
  const [tagMembersLoading, setTagMembersLoading] = useState<boolean>(false);
  const [selTagId, setSelTagId] = useState<number>(-1);

  const getTagMember = async (tagId: number) => {
    try {
      if (tagId <= 0) {
        setTagMembers([]);
      } else {
        setTagMembersLoading(true);
        const api = new APIClient;
        api.fnPostForm(urls.WP_LOAD_TAG_MEMBER_DTL, { tagId: tagId })
          .then(rs => {
            setTagMembers(rs);
            setTagMembersLoading(false);
          })
          .catch(e2 => {
            Utils.HandleException(e2, true);
            setTagMembersLoading(false);
          });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  useEffect(() => { getTagMember(selTagId) }, [selTagId]);


  interface TagBodyProps {
    onClickTag(tagId: number, tagName: string, isAdd: boolean): void;
    tagCat: WorkPlaceCatFilter;
    tagFilter: string;
  }

  const TagBody: React.FC<TagBodyProps> = ({ onClickTag, tagCat, tagFilter }) => {
    const tagToShow = (tagCat.tags ?? []).filter(e => tagFilter === "" || Utils.IsMatchAny(e.name, tagFilter));
    return (
      // <button onClick={() => { onClickTag() }}>test</button>
      <div ref={divContainer} className="container"  >
        <div className="row">
          <div className="col-md-7 col-lg-7 col-xl-7">
            <div style={{ position: "relative" }}>
              {tagCat.isSearching && (<Loader />)}
              {/* {tagCat.showSearchBox && (
                <div>
                  <TextBox placeholder="ค้นหา" icon13css="fas fa-search" icon13small={true} style={{ padding: "2px" }} value={"filter"} onChange={(e) => setFilter(e.target.value)} onEnter13={onSearchTagIn}  />
                </div>
              )} */}
              <AppSimpleBar style={{ maxHeight: "200px" }}>
                <div className="ps-2 pt-1 pb-2">
                  {/* all tag from database */}
                  {/* {(tagCat.tags ?? []).filter(e => tagFilter === "" || Utils.IsMatchAny(e.name, tagFilter)).map((tag: any, index: number) => ( */}
                  {tagToShow.map((tag: any, index: number) => (
                    <span key={tag.tagId}
                      className={classnames("wp-tag-filter hand mb-2 hover", { "wp-tag-filter-sel": tag.selected })}

                    >
                      <span onClick={() => { setSelTagId(tag.tagId) }}><i className={"text-primary"}></i> {tag.name}</span>
                      <i className="fas fa-plus-circle ms-1 text-primary" onClick={() => { onClickTag(tag.tagId, tag.name, true); setSelTagId(tag.tagId) }}></i>
                    </span>
                  ))}
                </div>
              </AppSimpleBar>
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-5">
            <div style={{ position: "relative" }}>

              <AppSimpleBar className="wp-tag-toolbox-mem" style={{ height: "170px" }}>
                {tagMembersLoading && (<Loader />)}
                {tagMembers.length <= 0 && selTagId <= 0 && (<div>ยังไม่ได้เลือก tag</div>)}
                {tagMembers.length <= 0 && selTagId > 0 && (<div>ไม่มีสมาชิก...</div>)}
                {tagMembers.map((mem, index) => (
                  <>
                    <div className="d-flex justify-content-between align-items-center hover">
                      <div className="d-flex" style={{ justifyContent: "left" }}>
                        {/* <div style={{ display: "flex", alignItems: "center" }}>
                          <UserAvatar profileImage={mem.pictureUrl ?? ""} bgColor={""} foreColor={""} abbrName={""} />
                        </div> */}
                        <div style={{ marginBottom: "2px" }}>
                          <div className="text-truncate">{mem.displayName2}</div>
                          <div className="text-secondary fz-08 text-truncate" style={{ marginTop: "-6px", marginLeft: "2px" }} >{mem.positionName}</div>
                        </div>
                      </div>
                      {/* <div className="">
                        {mem.memberRoleText}
                      </div> */}
                    </div>

                  </>
                ))}
              </AppSimpleBar>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const [filter, setFilter] = useState<string>("");

  const abortControllerRef = useRef<AbortController | null>(null);

  const debounceFindTag = useCallback(
    debounce(async (category: string[], filter: string) => {
      // Cancel the previous request if it exists
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // Create a new AbortController for this request
      abortControllerRef.current = new AbortController();

      const formData = new FormData();
      // formData.append('cat', category);
      // category.forEach(catVal => {
      //   formData.append('cat', catVal.toString()); // same key multiple times
      // });
      category.forEach(cat => formData.append('cat', cat));
      formData.append('filter', filter);
      formData.append('source', Const.SEARCH_TAG_FROM_FILTER_PANE_DIALOG_TAG.toString());
      console.log('api call:', formData);

      fetch(process.env.REACT_APP_APIURL + urls.WP_SEARCH_TAG_FROM_FILTER_PANE, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
        },
        body: formData,
        signal: abortControllerRef.current.signal,
      })
        .then((res) => {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then((data) => {
          //onSearchResult(tagCat.category, data);
          console.log('Result:', data);
          setAllTags(prev => prev.map(t =>
            category.includes(t.category) ?
              { ...t, tags: data.filter((x: any) => x.category == t.category) }
              : t
          ));
        })
        .catch((err) => {
          if (err.name === 'AbortError') {
            console.log('Previous request aborted');
          } else {
            console.error('Fetch error:', err);
          }
        });

    }, 800),
    []
  );

  useEffect(() => {
    if (filter) {
      const cats = allTags.filter(cat => cat.showSearchBox).map(e => e.category);
      if (cats && cats.length > 0) {
        console.log('cats:', cats);
        debounceFindTag(cats, filter);
      }
    }

    // Cleanup function to cancel any pending request when component unmounts
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [filter, debounceFindTag]);

  return (
    <div >
      {/* <button onClick={() => setSelTab("")}>test</button> */}
      <div className="accordion-body position-relative ps-1 pb-1 " style={{ paddingTop: "0px", fontSize: "0.95em"/*, minHeight:"30px"*/ }}>
        {selectedTags.map((tag, index) => (
          <span
            key={index} className="wp-tag-filter hand mb-2 hover"
            onClick={(e) => onClickTag(tag.tagId, tag.tagName, false)}
          ><i className="text-primary"></i> {tag.tagName}
          </span>
        ))}

        {/* <span className="wp-tag-filter hand mb-2 hover"><i className="text-primary"></i> Chat.2S</span>
        <span className="wp-tag-filter hand mb-2 hover"><i className="text-primary"></i> Chat.2S</span>
        <span className="wp-tag-filter hand mb-2 hover"><i className="text-primary"></i> Chat.2S</span>
        <span className="wp-tag-filter hand mb-2 hover"><i className="text-primary"></i> Chat.2S</span>
        <span className="wp-tag-filter hand mb-2 hover"><i className="text-primary"></i> Chat.2S</span>
        <span className="wp-tag-filter hand mb-2 hover"><i className="text-primary"></i> Chat.2S</span> */}
      </div>

      <TextBox placeholder="กรอง/ค้นหา แทก" className="form-control p-1" value={filter} onChange={(e) => setFilter(e.target.value)} />
      <Tabs activeKey={selTab} onSelect={(key) => { setSelTab(key as string); setSelTagId(-1); }} >
        {allTags.filter(cat => cat.showSearchBox || (cat.tags ?? []).length > 0).map((cat, index) => {
          const tags = (cat.tags ?? []).map(x => x.name);
          // console.log(cat.name + ':', tags);
          const haveTags = tags.length > 0 && (filter === "" || Utils.IsMatchAnyInArray(tags, filter));
          return (
            <Tab
              key={cat.category}
              eventKey={cat.category}
              title={<span className={classnames({ "wp-cat-no-tag": !haveTags })}><i className={cat.faIcon} ></i> {cat.name}</span>}
            >
              <TagBody onClickTag={onClickTag} tagCat={cat} tagFilter={filter} />

            </Tab>
          )
        })}
      </Tabs>

    </div>
  );
};

export default WpTagToolbox;
